module.exports = __webpack_public_path__ + "static/media/listen-again.db408adf.png";